/**
 * Ensure a start slash on any string you pass
 * @example
 * ```
 * cleanStartSlash('/path/to'); // 'path/to'
 * ```
 * @param path
 */
export function cleanStartSlash(path: string): string {
    return path.replace(/^\//g, '');
}

/**
 * Ensure an end slash on any string you pass
 * @example
 * ```
 * cleanEndSlash('path/to/'); // 'path/to'
 * ```
 * @param path
 */
export function cleanEndSlash(path: string): string {
    return path.replace(/\/$/g, '');
}

/**
 * Ensure start & end slashes on any string you pass
 * @example
 * ```
 * cleanSlashes('/path/to/'); // 'path/to'
 * ```
 * @param path
 */
export function cleanSlashes(path: string): string {
    const newPath = path
        .split('/')
        .map((seg) => `${seg}`.trim())
        .filter((seg) => !!seg)
        .join('/');

    return newPath.replace(':/', '://');
}
